import type { Finding, FindingCode, FindingOf } from "./Finding";

// Находки одного кода с точным типом `params`.
export const findingsOf = <C extends FindingCode>(
  findings: readonly Finding[],
  code: C,
): FindingOf<C>[] => findings.filter((finding): finding is FindingOf<C> => finding.code === code);
